export enum ValidationTypes {
  Text = 'text',
  Date = 'date',
  Unknown = 'unknown'
}
